var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticStyle:{"max-height":"90vh","overflow-y":"auto"},attrs:{"dark":"","color":_vm.color}},[_c('v-card',[_c('v-card-title',[_vm._v("Browser Compatability")]),_c('v-card-text',[_c('CompatabilityTable')],1),_c('v-card-subtitle',[_vm._v("Not limited to but explicitly tested for the following browser and OS versions")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }